<template>
  <BaseModal
    show
    size="sm"
    @close="$emit('cancel')"
  >
    <div class="mt-3">
      <div class="flex items-center justify-center w-12 h-12 mx-auto bg-red-100 dark:bg-red-900/30 rounded-full">
        <svg
          class="w-6 h-6 text-red-600 dark:text-red-400"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.464 0L4.35 16.5c-.77.833.192 2.5 1.732 2.5z"
          />
        </svg>
      </div>
      <div class="mt-4 text-center">
        <h3 class="text-lg font-medium text-gray-900 dark:text-white">
          Eliminar {{ itemType }}
        </h3>
        <div class="mt-2 px-7 py-3">
          <p class="text-sm text-gray-500 dark:text-gray-400">
            ¿Estás seguro de que quieres eliminar este {{ itemType }}? Esta acción no se puede deshacer.
          </p>
          <p
            v-if="item && item.name"
            class="mt-2 text-sm font-medium text-gray-900 dark:text-white"
          >
            "{{ item.name }}"
          </p>
        </div>
        <div class="flex justify-center space-x-4 mt-4">
          <button
            class="px-4 py-2 bg-gray-300 dark:bg-gray-600 text-gray-700 dark:text-gray-300 rounded-lg hover:bg-gray-400 dark:hover:bg-gray-500 transition-colors"
            @click="$emit('cancel')"
          >
            Cancelar
          </button>
          <button
            class="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
            @click="$emit('confirm')"
          >
            Eliminar
          </button>
        </div>
      </div>
    </div>
  </BaseModal>
</template>

<script setup lang="ts">
import BaseModal from '@/components/common/BaseModal.vue';

interface Props {
  item?: any;
  itemType: string;
}

interface Emits {
  (e: 'confirm'): void;
  (e: 'cancel'): void;
}

defineProps<Props>();
defineEmits<Emits>();
</script>
